/**
 * 缓动函数集合
 */

/**
 * easeOutQuart
 * @param t - time (0 to 1)
 * @returns eased value
 */
export function easeOutQuart(t: number): number {
  return 1 - Math.pow(1 - t, 4);
}
